import type { ListIncidentsRequest } from '../../services/driftApi';

// Query keys for React Query
export const queryKeys = {
  dashboard: ['dashboard'] as const,
  health: ['health'] as const,
  serverInfo: ['serverInfo'] as const,
  restartStatus: ['restartStatus'] as const,
  routes: ['routes'] as const,
  logs: ['logs'] as const,
  metrics: ['metrics'] as const,
  config: ['config'] as const,
  validation: ['validation'] as const,
  envVars: ['envVars'] as const,
  fixtures: ['fixtures'] as const,
  smokeTests: ['smokeTests'] as const,
  import: ['import'] as const,
  importHistory: ['importHistory'] as const,
  chaosConfig: ['chaosConfig'] as const,
  chaosStatus: ['chaosStatus'] as const,
  chaosLatencyMetrics: ['chaosLatencyMetrics'] as const,
  chaosLatencyStats: ['chaosLatencyStats'] as const,
  networkProfiles: ['networkProfiles'] as const,
  networkProfile: (name: string) => ['networkProfile', name] as const,
  timeTravelStatus: ['timeTravelStatus'] as const,
  cronJobs: ['cronJobs'] as const,
  mutationRules: ['mutationRules'] as const,
  proxyRules: ['proxyRules'] as const,
  proxyInspect: ['proxyInspect'] as const,
  realityLevel: ['realityLevel'] as const,
  realityPresets: ['realityPresets'] as const,
  lifecyclePresets: ['lifecyclePresets'] as const,
  lifecyclePreset: (name: string) => ['lifecyclePreset', name] as const,
  // Drift budget and incidents
  driftBudgets: ['driftBudgets'] as const,
  driftBudget: (id: string) => ['driftBudget', id] as const,
  driftIncidents: (params?: ListIncidentsRequest) => ['driftIncidents', params] as const,
  driftIncident: (id: string) => ['driftIncident', id] as const,
  driftIncidentStats: ['driftIncidentStats'] as const,
};
